<div class="list" [attr.data-display-mode]="displayMode">
  <div class="options">
    <mat-button-toggle-group [(ngModel)]="useTimezone" (change)="setupTimezone()">
      <mat-button-toggle value="local">
        Local
      </mat-button-toggle>
      <mat-button-toggle value="et">
        ET
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (state === 'loading') {
    @for (n of [].constructor(8); track $index) {
      <div class="item placeholder">
        <div class="info">
          <div class="title"><span class="placeholder"></span></div>
          <time><span class="placeholder"></span></time>
          <div class="description"><span class="placeholder"></span></div>
        </div>
      </div>
    }
  }
  @if (state === 'ready') {
    @if (getActiveAdhocStreams().length === 0 && liveEvents.length === 0) {
      <div class="empty">
        <em>No live events are currently scheduled. Check back later!</em>
      </div>
    }

    @for (stream of getActiveAdhocStreams(); track stream.id) {
      <a [routerLink]="'/live/streams/' + stream.id">
        <div class="item adhoc">
          <div class="badge now">Now</div>
          <div class="info">
            <h1>{{stream.title || 'Ad-Hoc Stream'}}</h1>
            <div class="chip-container">
              <div class="chip live">
                <span class="material-icons">sensors</span> Live
              </div>
            </div>
            <div class="description">{{stream.description}}</div>
          </div>
        </div>
      </a>
    }
    @for (liveSchedule of liveEvents; track liveSchedule) {
      <a [routerLink]="liveStreamRoute(liveSchedule)" [queryParams]="{ show: liveSchedule.show.id }">
      <div class="item" [class.live]="getEventStream(liveSchedule)">
        @if (showBadge) {
          <div class="badge" [class.now]="isLiveNow(liveSchedule)" [class.next]="nextItem == liveSchedule" [class.visible]="isLiveNow(liveSchedule) || nextItem == liveSchedule">
            @if (isLiveNow(liveSchedule)) {
              Now
            } @else {
              Next
            }
          </div>
        }

        <div class="info-container">
          @if(displayMode !== 'compact') {
            <picture
              class="mobile"
              responsive
              [src]="liveSchedule.show.logo_square"
              aria-hidden="true"
              ></picture>
          }

          <div class="info">
            <h1>
              @if (liveSchedule.show) {
                {{liveSchedule.show.name}}
              } @else {
                {{liveSchedule.title}}
              }
            </h1>
            <div class="chip-container">
              @if(showTime) {
                <time [attr.datetime]="airTimeForItem(liveSchedule) | isoDate">
                  @if (isLiveBySchedule(liveSchedule)) {
                    On until {{ endTimeForItem(liveSchedule) | date: 'h:mm a' : timezone }}
                    {{timezoneLabel}}
                  } @else {
                    @if (!isToday(liveSchedule)) {
                      {{liveSchedule.day}}
                    }

                    {{airTimeForItem(liveSchedule) | date : 'h:mm a' : timezone}}
                    {{timezoneLabel}}
                  }
                </time>
              }
              @if(showChip) {
                <div class="chip" [class.active]="isLiveNow(liveSchedule)" [class.live]="!liveSchedule.is_replay" [class.replay]="liveSchedule.is_replay">
                  @if (liveSchedule.is_replay) {
                    <span class="material-icons">fast_rewind</span> Replay
                  } @else {
                    <span class="material-icons">sensors</span> Live
                  }
                </div>
              }
            </div>

            @if (showSubtitle && liveSchedule.show && liveSchedule.use_title) {
              <div class="subtitle">{{liveSchedule.title}}</div>
            }

            @if(liveSchedule.description && showDescription) {
              <div class="description">{{liveSchedule.description}}</div>
            }
          </div>
        </div>

        @if(displayMode !== 'compact') {
          <picture
            class="desktop"
            responsive
            [src]="liveSchedule.show.logo_square"
            aria-hidden="true"
            ></picture>
        }
      </div>
    </a>
    }
  }
  @if(isFullLiveSchedule === false){
  <div class="full-schedule-link">
    <a mat-button routerLink="/live/schedule">Full Schedule</a>
  </div>
  }
</div>
